var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
export default styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", " {\n    ", "\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var $marginBottom = _ref2.$marginBottom,
    $marginLeft = _ref2.$marginLeft,
    $marginRight = _ref2.$marginRight,
    $marginTop = _ref2.$marginTop,
    theme = _ref2.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      margin: ", "\n        ", "\n        ", "\n        ", ";\n    "])), theme["spacing_".concat($marginTop)], theme["spacing_".concat($marginRight)], theme["spacing_".concat($marginBottom)], theme["spacing_".concat($marginLeft)]);
});